import { JsonObject, JsonProperty, JsonDelayedProperty } from 'projects/core/src/public-api';
import { TrelloObject } from './trello-object';
import { TrelloList } from './trello-list';
import { TrelloChecklist } from './trello-checklist';

@JsonObject('model.trello.TrelloCard')
export class TrelloCard extends TrelloObject {
    @JsonProperty(Number, 'pos')
    pos?: number;

    @JsonProperty(TrelloList, 'list')
    list?: TrelloList;

    @JsonDelayedProperty('TrelloCard', '[TrelloChecklist]', 'checklists')
    // @JsonProperty([TrelloChecklist], 'checklists')
    checklists?: TrelloChecklist[];
}